<template>
  <div class="calico-sub-header">
    <div class="title">
      <h1 class="heading--medium">
        {{ title }}
      </h1>
      <label class="label--medium">
        <CalicoTooltip
          v-if="tooltipBody"
          :header="tooltipHeader"
          :body="tooltipBody"
        />
      </label>
    </div>

    <div class="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="tab"
        :class="[tab.disabled ? 'tab--disabled' : '']"
      >
        <CalicoNavigationTab
          variant="alt"
          :disabled="tab.disabled"
          :to="tab.to"
        >
          <i :class="tab.icon" />
          <label class="label--medium">
            {{ tab.label }}
          </label>
        </CalicoNavigationTab>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoTooltip from '@/components/calico/tooltip/index.vue';
import CalicoNavigationTab from '@/components/calico/navigationTab/index.vue';

export default {
  name: 'CalicoSubHeader',
  components: {
    CalicoTooltip,
    CalicoNavigationTab
  },

  props: {
    title: { type: String, required: true },
    tooltipHeader: { type: String, default: '' },
    tooltipBody: { type: String, default: '' },
    tabs: { type: Array, required: true }
  }
};
</script>

<style scoped lang="scss">
.calico-sub-header {
  @include stack-space($space-small);

  .title {
    @include inline-space($space-xsmall);
    align-items: center;
  }

  .tabs {
    @include inline-space($space-xsmall);
    width: 100%;
  }

  .tab {
    flex: 1 1 0;
    min-width: 0;
    @include inline-space($space-xsmall);
    align-items: center;
    justify-content: center;

    :deep(.calico-navigation-tab) {
      width: 100%;
    }

    :deep(.link) {
      width: 100%;
      justify-content: center;
    }
  }

  .tab--disabled :deep(.link) {
    color: $color-neutral;
    pointer-events: none;
    background-color: transparent !important;
  }

  @media (max-width: $mobile-breakpoint-max-width) {
    .title {
      justify-content: center;
    }

    .tabs {
      width: 100%;
    }

    .tab i {
      display: none;
    }
  }
}
</style>